export const getInitialState = () => ({
  data: {
    modalDisplay: false,
    csat: {
      display: false,
      submitted: false,
    },
  },
});

export const state = getInitialState();
